import _ from 'underscore';

import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';

const i18n = globalContext.require('$/i18n!legacy/global');

const { arrowDownIcon } = globalContext.require('component/bingads-grid/shared/icons');
const globalConfig = globalContext.require('component/config/index');

const { IsManagementDashboardEnabled } = globalConfig.get('Permissions');

export default definePlugin => definePlugin('bulkAccountManagement', [
  'config',
  'gridView',
  'toolbar',
], (config, gridView, toolbar) => {
  const {
    dropdown = 'dropdown-edit',
    enabled = false,
  } = _.chain(config).result('plugins').result('bulkAccountManagement').value();
  const toolbarEditor = toolbar.gridToolbarGroup.toolbarWithItem(dropdown);

  if (!enabled) {
    toolbarEditor.update({
      id: dropdown,
      attributes: { style: 'display: none;' },
    });
    return;
  }

  function buildBulkSheet() {
    const accountNumberList = _.map(
      gridView.selectedKeys(),
      key => _.result(gridView.itemWithKey(key), 'AccountNumber')
    );

    window.App.trigger('accounts.bam.loadQueryBuilder', { accountNumberList });
  }

  function uploadBulkSheet() {
    window.App.trigger('accounts.bam.loadBulkUploads');
  }

  gridView.set({
    selection: {
      bodyClasses: ['text-center'],
      headClasses: ['text-center'],
    },
  });

  toolbarEditor.update({
    id: dropdown,
    button: {
      classes: IsManagementDashboardEnabled ? ['btn', 'btn-secondary'] : ['btn', 'btn-primary'],
      text: i18n.getString('Edit'),
      iconRight: arrowDownIcon,
    },
    menu: {
      items: [{
        text: i18n.getString('Bulk_Download_Edit_Title'),
        onClick: buildBulkSheet,
      }, {
        text: i18n.getString('BulkUpload_MenuItem_Title'),
        onClick: uploadBulkSheet,
      }],
    },
  });
});

